﻿import type { AdminLifeSignalItem, AdminLifeSignalSummary } from "@/types.ts";
interface TodaySummaryCardProps {
    summary: AdminLifeSignalSummary | null;
    items: AdminLifeSignalItem[];
}
const TodaySummaryCard = ({ summary, items }: TodaySummaryCardProps) => {
    const total = Math.max(items.length, 1);
    const needsAttention = summary?.totalNeedsAttentionCount ?? 0;
    const noResponse = summary?.scheduleNoResponseCount ?? 0;
    const offline = summary?.offlineDeviceCount ?? 0;
    const normal = Math.max(items.length - needsAttention, 0);
    const viewItems = [
        { label: "정상", value: `${normal}명`, count: normal, color: "text-emerald-600", barColor: "bg-emerald-500" },
        { label: "확인 필요", value: `${needsAttention}명`, count: needsAttention, color: "text-orange-600", barColor: "bg-orange-500" },
        { label: "무응답", value: `${noResponse}명`, count: noResponse, color: "text-amber-600", barColor: "bg-amber-500" },
        { label: "오프라인 기기", value: `${offline}대`, count: offline, color: "text-red-600", barColor: "bg-red-500" },
    ];
    return (<div className="bg-white rounded-lg border border-slate-200 shadow-sm p-4">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-4 h-4 flex items-center justify-center">
          <i className="ri-bar-chart-line text-slate-500 text-xs"/>
        </div>
        <h3 className="text-xs font-semibold text-slate-700">오늘 현황 요약</h3>
      </div>

      <div className="space-y-2.5">
        {viewItems.map((item) => (<div key={item.label} className="flex items-center justify-between">
            <span className="text-xs text-slate-500 w-20">{item.label}</span>
            <div className="flex items-center gap-2 flex-1">
              <div className="flex-1 h-1.5 bg-slate-100 rounded-full overflow-hidden">
                <div className={`h-full ${item.barColor} rounded-full`} style={{ width: `${(item.count / total) * 100}%` }}/>
              </div>
              <span className={`text-xs font-semibold ${item.color} w-12 text-right`}>{item.value}</span>
            </div>
          </div>))}
      </div>

      <div className="mt-3 pt-2.5 border-t border-slate-100 flex items-center justify-between">
        <span className="text-xs text-slate-400">전체</span>
        <span className="text-xs font-bold text-slate-700">{items.length}명</span>
      </div>
    </div>);
};
export default TodaySummaryCard;
